/**
 * Tab navigation for UserSettingsModal — horizontal on mobile, vertical
 * sidebar on desktop.
 */

import React from 'react';

export type SettingsTab = 'notifications' | 'profile' | 'appearance';

const TABS: { id: SettingsTab; icon: string; label: string }[] = [
  { id: 'notifications', icon: 'fa-bell', label: 'Notifications' },
  { id: 'profile', icon: 'fa-id-card', label: 'Profile' },
  { id: 'appearance', icon: 'fa-palette', label: 'Appearance' },
];

interface SettingsTabNavProps {
  activeTab: SettingsTab;
  onTabChange: (tab: SettingsTab) => void;
}

export const SettingsTabNav: React.FC<SettingsTabNavProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex sm:flex-col gap-1 sm:gap-0 sm:w-48 border-b sm:border-b-0 sm:border-r border-line pb-3 sm:pb-0 sm:pr-4 mb-4 sm:mb-0 sm:space-y-1">
      {TABS.map(({ id, icon, label }) => (
        <button
          key={id}
          onClick={() => onTabChange(id)}
          // Phone: icon stacked over a text-xs label so all three tabs fit a
          // ~300px row ("Appearance" was clipped when they sat side by side).
          className={`flex-1 min-w-0 sm:flex-none sm:w-full text-center sm:text-left px-1 sm:px-4 py-2 sm:py-3 rounded-lg flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-1 sm:gap-3 transition-colors text-xs sm:text-base ${
            activeTab === id
              ? 'bg-hue-blue-subtle text-hue-blue-deep font-medium'
              : 'text-ink-body hover:bg-surface-muted'
          }`}
        >
          <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
          <span className="max-w-full truncate">{label}</span>
        </button>
      ))}
    </div>
  );
};
